import { getSamples } from '../../controllers/ExcursionController';
import React, { useState, useEffect } from 'react';

function SamplesList({ id }) {
    const [samples, setSamples] = useState([]);
    useEffect(() => {
        getSamples(id)
            .then((data) => {
                console.log("API Response:", data);
                setSamples(data);
            })
            .catch((error) => {
                console.error("Error fetching samples data:", error);
                setSamples([]);
            });
    }, [id]);
    return (
        <div className="SamplesList">
            <h3>Liste des prélèvements</h3>
            <ul>
               {samples.length > 0 ? (
                   samples.map((sample, index) => (
                       <li key={index}>
                           <p>{sample}</p>
                       </li>
                   ))
               ) : (
                   <li>Aucun prélèvement</li>
               )}
            </ul>
        </div>
    );
}

export default SamplesList;